export const loading_on = 'loadingOn'
export const loading_off = 'loadingOff'
export const set_user = 'setUser'
